import React, { useState, useEffect } from "react";
export default function Customers() {
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState({ name: "", email: "", phone: "", address: "", gstin: "", state_code: "08" });

  const loadData = () => fetch('/api/customers').then(r=>r.json()).then(d=>setData(Array.isArray(d)?d:[]));
  useEffect(() => { loadData(); }, []);

  const handleGstin = (e) => {
    const val = e.target.value.toUpperCase();
    let sc = form.state_code;
    if (val.length >= 2) {
      const prefix = val.substring(0, 2);
      if (!isNaN(prefix) && prefix.trim() !== "") sc = prefix;
    }
    setForm({ ...form, gstin: val, state_code: sc });
  };

  const save = async (e) => {
    e.preventDefault();
    const url = editId ? `/api/customers/${editId}` : '/api/customers';
    const method = editId ? 'PUT' : 'POST';
    await fetch(url, { method, headers: {'Content-Type':'application/json'}, body: JSON.stringify(form) });
    setShow(false); setEditId(null); loadData(); 
    setForm({ name: "", email: "", phone: "", address: "", gstin: "", state_code: "08" });
  };

  const handleEdit = (c) => {
    setForm({ name: c.name||"", email: c.email||"", phone: c.phone||"", address: c.address||"", gstin: c.gstin||"", state_code: c.state_code||"08" });
    setEditId(c.id);
    setShow(true);
  };

  const handleDelete = async (id) => {
    if(window.confirm("Kya aap sach mein is client ko delete karna chahte hain?")) {
       await fetch(`/api/customers/${id}`, { method: 'DELETE' });
       loadData();
    }
  };

  const cancelEdit = () => {
    setShow(false); setEditId(null);
    setForm({ name: "", email: "", phone: "", address: "", gstin: "", state_code: "08" });
  };

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="flex justify-between mb-4">
         <h1 className="text-2xl font-bold">Clients</h1>
         <button onClick={()=>{setShow(true); setEditId(null); setForm({ name: "", email: "", phone: "", address: "", gstin: "", state_code: "08" });}} className="bg-emerald-600 text-white px-4 py-2 rounded shadow">+ Add Client</button>
      </div>
      {show && (
        <form onSubmit={save} className="bg-white p-4 shadow mb-4 grid grid-cols-3 gap-4 rounded relative">
          <button type="button" onClick={cancelEdit} className="absolute top-2 right-4 text-red-500 font-bold hover:underline">✕ Close</button>
          <input placeholder="Client Name" required className="border p-2 mt-4" value={form.name} onChange={e=>setForm({...form, name:e.target.value})} />
          <input placeholder="GSTIN (e.g. 08AAAAA...)" className="border p-2 uppercase mt-4" value={form.gstin} onChange={handleGstin} />
          <input placeholder="State Code (Auto/Manual)" required className="border p-2 mt-4" value={form.state_code} onChange={e=>setForm({...form, state_code:e.target.value})} />
          <input placeholder="Address" className="border p-2 col-span-3" value={form.address} onChange={e=>setForm({...form, address:e.target.value})} />
          <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded col-span-3 font-bold">{editId ? "Update Client Details" : "Save Client"}</button>
        </form>
      )}
      <div className="bg-white shadow p-4 rounded overflow-x-auto">
        <table className="min-w-full text-left">
          <thead><tr className="border-b text-gray-500"><th className="pb-2">Name</th><th className="pb-2">GSTIN</th><th className="pb-2">State Code</th><th className="pb-2">Address</th><th className="pb-2 text-right">Actions</th></tr></thead>
          <tbody>{data.map((c,i)=><tr key={i} className="border-b hover:bg-gray-50"><td className="py-3 font-medium">{c.name}</td><td className="text-gray-600">{c.gstin || "-"}</td><td className="font-bold">{c.state_code}</td><td>{c.address || "-"}</td>
          <td className="text-right whitespace-nowrap">
             <button onClick={()=>handleEdit(c)} className="text-blue-600 font-bold mr-4 hover:underline">Edit</button>
             <button onClick={()=>handleDelete(c.id)} className="text-red-600 font-bold hover:underline">Delete</button>
          </td>
          </tr>)}</tbody>
        </table>
      </div>
    </div>
  );
}
